module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-fr-d9d87cda.webp";